import Footer from '@/components/Footer'
import Header from '@/components/Header'
import { SkipLink } from '@/components/SkipLink'
import { type ReactNode } from 'react'

type LayoutProps = {
  headerHTML: string
  footerHTML: string
  children: ReactNode
}

function Layout({ headerHTML, footerHTML, children }: LayoutProps) {
  return (
    <>
      <SkipLink />
      <Header headerHTML={headerHTML} />
      <main id='main-content' tabIndex={-1}>
        {children}
      </main>
      <Footer footerHTML={footerHTML} />
    </>
  )
}

export default Layout
